import type { FC } from "react";
import { memo } from "react";

import { useTranslations } from "@ui/providers/useTranslations";

import { RadioButton } from "@jti/core-components";
import type { AgeVerificationMethodType } from "@jti/fe-common";

import styles from "./MethodType.module.scss";

type IMethod = {
  method: AgeVerificationMethodType;
  isSingleMethod: boolean;
  selectedMethod: string;
  selectMethod: (selectedMethod: string) => void;
};

export const MethodType: FC<IMethod> = memo(({ method, selectedMethod, isSingleMethod, selectMethod }) => {
  const { __ } = useTranslations();
  const handleMethod = (event: React.ChangeEvent<HTMLInputElement>) => {
    selectMethod(event.target.value);
  };

  if (isSingleMethod) return null;
  return (
    <div className={`${styles.methodTitle} ${selectedMethod === method.code ? styles.checkedRadio : ""}`}>
      <RadioButton
        data-testid={method.code}
        key={method.code}
        value={method.code}
        id={method.code}
        onChange={handleMethod}
        checked={selectedMethod === method.code}
        label={__(`auth.age_verification.method.${method.code}.title`, [], method.name)}
      />
    </div>
  );
});
